import {
  EVENTS_NEWS_REQUEST,
  EVENTS_NEWS_SUCCESS,
  EVENTS_NEWS_FAIL,
  CREATE_EVENTS_NEWS_REQUEST,
  CREATE_EVENTS_NEWS_SUCCESS,
  CREATE_EVENTS_NEWS_FAIL,
  UPDATE_EVENTS_NEWS_REQUEST,
  UPDATE_EVENTS_NEWS_SUCCESS,
  UPDATE_EVENTS_NEWS_FAIL,
  DELETE_EVENTS_NEWS_REQUEST,
  DELETE_EVENTS_NEWS_SUCCESS,
  DELETE_EVENTS_NEWS_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/eventsAndNewsConstants";

const initialState = {
  eventsNews: [],
  loading: false,
  error: null,
};

export const eventsNewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case EVENTS_NEWS_REQUEST:
    case CREATE_EVENTS_NEWS_REQUEST:
    case UPDATE_EVENTS_NEWS_REQUEST:
    case DELETE_EVENTS_NEWS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case EVENTS_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        eventsNews: action.payload,
      };

    case CREATE_EVENTS_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        eventsNews: [...state.eventsNews.data, action.payload],
      };

    case UPDATE_EVENTS_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        eventsNews: state.eventsNews.data.map((event) =>
          event._id === action.payload._id ? action.payload : event
        ),
      };

    case DELETE_EVENTS_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        eventsNews: state.eventsNews.data.filter(
          (event) => event._id !== action.payload
        ),
      };

    case EVENTS_NEWS_FAIL:
    case CREATE_EVENTS_NEWS_FAIL:
    case UPDATE_EVENTS_NEWS_FAIL:
    case DELETE_EVENTS_NEWS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
